
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitopuneonewaycab() {



    const cardData =
    {
        keyword: 'Mumbai to Pune One Way Cab',
        heading: 'Skyline Cabs: Mumbai to Pune One Way Cab',
        headingDescription: 'Skyline Cabs offers affordable and reliable Mumbai to Pune One Way Cab services for a hassle-free journey. Whether you are traveling for business, a quick visit, or heading back home, our one-way cab service is the perfect solution. Enjoy clean, well-maintained vehicles, courteous drivers, and on-time pickups at your preferred location in Mumbai. With transparent pricing and 24/7 availability, Skyline Cabs makes your travel from Mumbai to Pune smooth and convenient. Book your one-way cab today for a comfortable ride at the best price.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Mumbai Pune Cab One Way",
      "description": "Skyline Cabs offers one-way cab services from Mumbai to Pune for travelers seeking a cost-effective and reliable ride. Enjoy clean, air-conditioned vehicles with professional drivers and doorstep pickup and drop facilities."
    },
    {
      "name": "One Way Taxi Mumbai to Pune",
      "description": "Book a one-way taxi from Mumbai to Pune with Skyline Cabs for convenient and affordable intercity travel. Choose from sedans, Ertiga, or Innova Crysta for a smooth and timely journey."
    },
    {
      "name": "Mumbai Pune One Way Drop",
      "description": "Skyline Cabs provides dedicated one-way drop taxi services from Mumbai to Pune. Ideal for business or leisure travel, our service guarantees punctuality, comfort, and affordable pricing."
    },
    {
      "name": "One Way Cab Pune to Mumbai Airport",
      "description": "Need a one-way cab to Mumbai Airport from Pune? Skyline Cabs offers timely pickups and smooth airport transfers with our fleet of sedans and MUVs driven by courteous professionals."
    },
    {
      "name": "One Way Mumbai to Pune",
      "description": "Skyline Cabs offers seamless one-way cab services from Mumbai to Pune. Avoid return fares and travel comfortably with our well-maintained vehicles and trained chauffeurs."
    },
    {
      "name": "Pune to Mumbai Airport One Way Cab",
      "description": "Book a one-way cab from Pune to Mumbai Airport for a hassle-free airport transfer. Our services ensure on-time arrival with a choice of vehicles like Ertiga, Swift Dzire, and Innova Crysta."
    },
    {
      "name": "Mumbai Pune One Way Innova Taxi",
      "description": "Travel in comfort and style with Skyline Cabs' Innova taxi service for one-way rides from Mumbai to Pune. Spacious interiors and a smooth ride make it perfect for group or family travel."
    },
    {
      "name": "Mumbai Pune One Way Sedan Taxi",
      "description": "Skyline Cabs provides sedan taxis for one-way Mumbai to Pune travel. Enjoy economical fares and reliable service in sedans like Swift Dzire or Etios with experienced drivers."
    },
    {
      "name": "Mumbai to Pune One Way Ertiga Drop",
      "description": "Book an Ertiga for a spacious and budget-friendly one-way drop from Mumbai to Pune. Perfect for families or group travelers, Skyline Cabs ensures safe and comfortable rides."
    },
    {
      "name": "Mumbai to Pune One Way Cab",
      "description": "Skyline Cabs offers one-way cab rides from Mumbai to Pune. No need to pay for return—book once, travel stress-free with GPS-enabled vehicles and professional drivers."
    },
    {
      "name": "Mumbai Pune Cab One Way",
      "description": "Skyline Cabs makes one-way cab travel between Mumbai and Pune affordable and convenient. Choose your vehicle type and book online or via phone for instant confirmation."
    },
    {
      "name": "One Way Cab Pune to Mumbai",
      "description": "Looking for a single-side journey from Pune to Mumbai? Skyline Cabs provides economical one-way cabs with clean cars, safe driving, and on-time service—24x7 available."
    },
    {
      "name": "Pune to Mumbai Taxi One Way",
      "description": "Skyline Cabs provides reliable and fast taxi services for one-way trips from Pune to Mumbai. Perfect for last-minute travel or scheduled journeys with no hidden costs."
    },
    {
      "name": "Pune Mumbai Cab One Way",
      "description": "Get top-quality one-way cab service from Pune to Mumbai with Skyline Cabs. With our range of vehicles and courteous drivers, your trip will be safe, comfortable, and timely."
    },
    {
      "name": "Mumbai One Way Cab",
      "description": "Skyline Cabs offers city-to-city one-way cab solutions starting from Mumbai. Whether heading to Pune, Nashik, or elsewhere, we offer competitive pricing and clean vehicles."
    },
    {
      "name": "Mumbai Pune One Way Taxi",
      "description": "Book a one-way taxi from Mumbai to Pune at unbeatable prices. Our service includes all major vehicle types, trained drivers, and flexible booking options for your convenience."
    },
    {
      "name": "Best Cab Service Mumbai to Pune",
      "description": "Skyline Cabs is rated among the best for Mumbai to Pune cab service. With affordable one-way pricing, luxury vehicles, and 24/7 support, we ensure an excellent travel experience."
    }
  ],
  "tableData": [
    ["Mumbai Pune Cab One Way", "One Way Taxi Mumbai to Pune"],
    ["Mumbai Pune One Way Drop", "One Way Cab Pune to Mumbai Airport"],
    ["One Way Mumbai to Pune", "Pune to Mumbai Airport One Way Cab"],
    ["Mumbai Pune One Way Innova Taxi", "Mumbai Pune One Way Sedan Taxi"],
    ["Mumbai to Pune One Way Ertiga Drop", "Mumbai to Pune One Way Cab"],
    ["Mumbai Pune Cab One Way", "One Way Cab Pune to Mumbai"],
    ["Pune to Mumbai Taxi One Way", "Pune Mumbai Cab One Way"],
    ["Mumbai One Way Cab", "Mumbai Pune One Way Taxi"],
    ["Best Cab Service Mumbai to Pune", "One Way Pune to Mumbai"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Convenient Mumbai to Pune One Way Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers reliable and affordable one-way cab services from Mumbai to Pune. Skip the hassle of return bookings—just pay for the distance you travel. Ideal for business trips, quick getaways, and solo travelers looking for a cost-effective option without compromising on quality."
    },
    {
        "WhyChooseheading": "Comfortable and Clean Vehicles",
        "WhyChoosedescription": "Travel in style and comfort in our well-maintained fleet of sedans, SUVs, and luxury cars. All vehicles are air-conditioned, sanitized, and equipped with plush seating to ensure a smooth and relaxing one-way trip from Mumbai to Pune."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Our drivers are not only professional and courteous but also experts in navigating the Mumbai to Pune route. They ensure safe, efficient travel with minimal delays, and go the extra mile to provide a stress-free experience, especially on one-way bookings where timing matters most."
    },
    {
        "WhyChooseheading": "Affordable and Transparent One-Way Pricing",
        "WhyChoosedescription": "With Skyline Cabs, you only pay for what you use. Our one-way pricing from Mumbai to Pune is competitive and clearly stated—no hidden fees or surprise charges. Enjoy a premium service at a fair price without worrying about round-trip costs."
    },
    {
        "WhyChooseheading": "24/7 One Way Cab Availability",
        "WhyChoosedescription": "Whether you’re booking early morning, late at night, or even on short notice, Skyline Cabs is ready with 24/7 availability. No matter when you need to travel from Mumbai to Pune, our dependable service is just a call or click away."
    },
    {
        "WhyChooseheading": "Choice of Vehicles for Every Traveler",
        "WhyChoosedescription": "From solo commuters and couples to families or small groups, we have the right vehicle for your needs. Choose from fuel-efficient sedans, spacious SUVs, or luxury models depending on your comfort and budget preferences."
    },
    {
        "WhyChooseheading": "Simple Booking and Instant Confirmation",
        "WhyChoosedescription": "Booking your one-way cab from Mumbai to Pune is fast and simple. Use our website or mobile app to book in minutes and get instant confirmation. You can also track your driver live, manage payments digitally, and get support anytime during your trip."
    },
    {
        "WhyChooseheading": "Safe and Secure Ride Guaranteed",
        "WhyChoosedescription": "Your safety is our priority. All vehicles are GPS-enabled and driven by background-verified professionals. Whether it’s a day trip or a late-night ride, you can count on Skyline Cabs for a secure one-way journey from Mumbai to Pune."
    }
]















    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a one-way cab from Mumbai to Pune with Skyline Cabs?',
            answer:
                'You can book online through our website or mobile app. Simply select Mumbai as your pickup point, Pune as your drop-off destination, choose "One Way" and pick your preferred vehicle.',
        },
        {
            id: 2,
            question: 'Is the fare for Mumbai to Pune one-way travel fixed?',
            answer:
                'Yes, Skyline Cabs offers fixed and transparent pricing for one-way trips. The fare includes driver charges, tolls, and taxes — no hidden costs.',
        },
        {
            id: 3,
            question: 'What vehicle options are available for one-way trips?',
            answer:
                'We offer a wide range of vehicles including Sedans, SUVs, Ertiga, Innova Crysta, and luxury options. You can choose based on your group size and comfort preference.',
        },
        {
            id: 4,
            question: 'How long does it take to travel from Mumbai to Pune?',
            answer:
                'The journey typically takes 3 to 4 hours depending on traffic. Our experienced drivers use the best routes for a safe and timely arrival.',
        },
        {
            id: 5,
            question: 'Are Skyline Cabs suitable for airport pickups in Mumbai?',
            answer:
                'Yes, we offer one-way cab services from Mumbai Domestic and International airports directly to Pune. Share your flight details and we’ll manage everything for a smooth transfer.',
        },
        {
            id: 6,
            question: 'Can I get a cab at any time from Mumbai to Pune?',
            answer:
                'Absolutely! Skyline Cabs operates 24/7. Whether it’s an early morning trip or a late-night pickup, we’re always ready.',
        },
        {
            id: 7,
            question: 'What are the benefits of choosing a one-way cab instead of a round trip?',
            answer:
                'One-way cabs are ideal if you don’t plan to return the same day. You save on return fare and only pay for the journey you take.',
        },
        {
            id: 8,
            question: 'Is there customer support in case I need help during the ride?',
            answer:
                'Yes, our support team is available 24/7. Whether it’s a change in pickup point or a delay, we’re just a call away.',
        },
        {
            id: 9,
            question: 'Are your drivers experienced and professional?',
            answer:
                'Yes, all our drivers are experienced, background-verified, and trained for long-distance travel. Your safety and comfort are always our priority.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for one-way travel from Mumbai to Pune?',
            answer:
                'Skyline Cabs offers clean, air-conditioned cars, fixed pricing, and professional service — all at affordable rates. It’s the perfect option for safe and hassle-free one-way travel.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Sandeep Desai",
            rating: 5,
            review: "Booked a one-way cab from Mumbai to Pune and was really impressed. The driver arrived right on time, the car was clean, and the entire trip was smooth. Skyline Cabs is now my go-to for intercity travel."
        },
        {
            name: "Miss. Rupal Shah",
            rating: 4,
            review: "Took a one-way ride from Mumbai to Pune after a flight. The booking process was easy, and the car was in great condition. I’d give 5 stars if the driver had some bottled water ready — otherwise, it was perfect!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune One Way Cab",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-pune-one-way-cab.jpg",
  "description": "Book Mumbai to Pune one way cab with Skyline Cabs for a smooth, safe, and affordable ride. Get 24/7 AC cab service with professional drivers, ideal for solo, family, or business travel.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8352"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-pune-one-way-cab"
  }
};


      
      

    return (
        <div>
<Helmet>
  <title>Mumbai to Pune One Way Cab | 24x7 AC Taxi at Best Price | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pune one way cab with Skyline Cabs for a smooth, safe, and affordable ride. Get 24/7 AC cab service with professional drivers, ideal for solo, family, or business travel." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Pune One Way Cab, One Way Taxi Mumbai to Pune, AC Cab Mumbai Pune One Way, Affordable Cab Mumbai to Pune, Skyline Cabs Mumbai Pune, One Side Cab Booking Mumbai to Pune, 24/7 Cab Mumbai to Pune, Sedan SUV One Way Taxi Mumbai Pune, Online One Way Cab Mumbai Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      


            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/32.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitopuneonewaycab;